import { Box } from '@mui/material';
import React from 'react';

import { useScope, useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import SiteGrid from './components/SiteGrid';

export function SiteGridView({
  match: { params },
  defaultStatus = 'active',
  persistScope = 'structureGrid',
  ...props
}) {
  const { customer, siteGroup: selectedPlant } = useScope();
  const { user } = useUser();

  return (
    <AppNav flex notFullHeight page="plant_list" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={null} />
        <SiteGrid
          customer={customer}
          selectedPlant={selectedPlant}
          user={user}
          defaultStatus={defaultStatus}
          persistScope={persistScope}
        />
      </Box>
    </AppNav>
  );
}

export default SiteGridView;
